import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useFormik} from 'formik';
import {useDispatch} from 'react-redux';
import * as _ from 'lodash';
import {useStreetsContext} from '../CitiesAndStreets';
import {StyledFieldInput} from '../FieldInput';
import {showGlobalMessage} from '../GlobalMessage/actions/showGlobalMessage';
import {filterOptionsByLabel} from '../../utils/filterOptions';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import ButtonAction from '../ButtonAction';
import ModalContainer from '../ModalContainer';
import ModalHeader from '../ModalHeader/ModalHeader';
import ModalButtonsContainer from '../ModalButtonsContainer';
import ModalContent from '../ModalContent';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../styles/styles';

const PopupContent = ({cityID, onSubmit, close}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const {addStreet} = useStreetsContext();

  const handleSubmit = async values => {
    const {errorMessage, list} = await addStreet(cityID, values.streetName);

    if (errorMessage) {
      await dispatch(showGlobalMessage('error', errorMessage));
    } else if (onSubmit) {
      const [selected] = filterOptionsByLabel(list)(values.streetName);
      await onSubmit(selected);
    }

    close();
  };

  const formik = useFormik({
    initialValues: {streetName: ''},
    validate: values => (values.streetName) ? {} : {streetName: 'required'},
    onSubmit: handleSubmit,
    enableReinitialize: true,
    validateOnMount: true,
  });

  const buttonLabelSubmit = intl.formatMessage({
    id: 'inspection-details-addStreet-label-popup-submit',
    defaultMessage: 'Submit',
  });
  const buttonLabelCancel = intl.formatMessage({
    id: 'inspection-details-addStreet-label-popup-cancel',
    defaultMessage: 'Close',
  });
  const fieldLabelStreet = intl.formatMessage({
    id: 'inspection-details-addStreet-label-popup-input',
    defaultMessage: 'Street'
  });
  const headerText = intl.formatMessage({
    id: 'inspection-details-addStreet-label-popup-header',
    defaultMessage: 'Input a new street name'
  });

  return (
    <>
      <ModalHeader header={headerText}/>
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldInput
          fieldId={'streetName'}
          value={_.get(formik.values, 'streetName')}
          label={fieldLabelStreet}
          onChange={formik.handleChange}
        />
      </ModalContent>
      <ModalButtonsContainer customClassnames={largeButtonsPadding}>
        <ButtonAction
          variant={'cancel'}
          label={buttonLabelCancel}
          onClick={close}
          customClassnames={buttonCancel}
        />
        <ButtonAction
          label={buttonLabelSubmit}
          useIcon={'/media/common/Check-in-circle_white.svg'}
          onClick={formik.submitForm}
          disabled={!(formik.isValid && cityID)}
          customClassnames={buttonSubmit}
        />
      </ModalButtonsContainer>
    </>
  );
};

const AddStreetPopup = ({buttonDisabled, ...props}) => {
  const intl = useIntl();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  return (
    <>
      <ButtonAction
        variant={'link'}
        title={intl.formatMessage({id: 'inspection-details-addStreet-label-button', defaultMessage: 'Add street'})}
        label={<img src={toAbsoluteUrl('/media/common/Plus_primary.svg')} alt="icon"/>}
        onClick={handleShowModal}
        disabled={buttonDisabled}
        customClassnames={`font-weight-bold text-dark text-nowrap bg ${buttonDisabled ? 'opacity-1 cursor-default' : ''}`}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <PopupContent
          close={handleCloseModal}
          {...props}
        />
      </ModalContainer>
    </>
  );
};

export default AddStreetPopup;
